import { FailedAlert, McInputNew, VSpace } from "../../../components";
import { Alert, Button } from "@mantine/core";
import { useCreateServiceAccountMutation } from "../../../globalRTK";
import React from "react";

export const ServiceAccounts: React.FC = () => {
  const [createServiceAccount, { isError, isSuccess, isUninitialized, data }] = useCreateServiceAccountMutation();

  const [serviceName, setServiceName] = React.useState<string>("");
  return (
    <div>
      {isSuccess && (
        <Alert color="green" variant="light">
          <b>{data.apiKey}</b>
        </Alert>
      )}
      {isError && <FailedAlert />}
      <McInputNew
        style={{ width: "100%" }}
        type="text"
        value={serviceName}
        onChange={(e) => setServiceName(e.target.value)}
        name="text"
      />
      <VSpace />
      <Button
        color="green"
        disabled={isUninitialized === false}
        onClick={() =>
          createServiceAccount({
            serviceName,
          })
        }
      >
        Add
      </Button>
    </div>
  );
};
